<div class="p-4 rounded-xl">
  <div class="flex justify-between items-center mb-4">
    <div>
      <h2 class="text-lg font-semibold">{{ 'QUESTIONNAIRE.ANSWER_SETUP.TITLE' | translate }}</h2>
      <p class="text-sm text-gray-500" *ngIf="qstSeq">{{ 'QUESTIONNAIRE.ANSWER_SETUP.QUESTION_ID' | translate: { id: qstSeq } }}</p>
    </div>

    <div class="flex gap-10 items-center">
      <button
        class="btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="!canAddAnswer"
        [title]="!canAddAnswer ? ((typeCategory === 'radio' ? 'QUESTIONNAIRE.ANSWER_SETUP.RADIO_FIXED' : 'QUESTIONNAIRE.ANSWER_SETUP.ONE_ANSWER_ONLY') | translate) : ''"
        (click)="canAddAnswer && openPopup()"
      >
        {{ 'QUESTIONNAIRE.ANSWER_SETUP.ADD_ANSWER' | translate }}
      </button>
      <app-back-button></app-back-button>
    </div>
  </div>

  <app-table [columns]="columns" [data]="list" [actions]="actions"></app-table>

  <app-popup
    [(show)]="showPopup"
    title="QUESTIONNAIRE.ANSWER_SETUP.TITLE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showDeletePopup"
    title="QUESTIONNAIRE.ANSWER_SETUP.DELETE_TITLE"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()"
  ></app-popup>
</div>
